<template>
  <div class="sharContainer">
    <div class="header pr">
      <!-- 安全规则管理 -->
      <header-tag :title="'规则共享大厅'"></header-tag>
      <div class="pa f14" style="right:50px;top:0;">规则问题反馈邮箱：safecenter@zwylwl.com</div>
      <div class="search">
        <input type="text" placeholder="请输入规则ID或规则名称" v-model="keyword" @keyup.enter="searchKeyword()"
          @blur="searchKeyword()" />
        <a href="#" class="pr cp" @click.prevent="searchKeyword()"><img src="@/assets/img/icon/u502.png"
            class="pa center" alt="" /></a>
      </div>
    </div>
    <!-- 表格部分 -->
    <div class="table-content">
      <table-list ref="tableList" @pagechange="getSafetyRulesList" @deleteAllRules="deleteAllRules"
        @rulesStatusAlls="rulesStatusAlls" @refresh="refresh" @openRule="openRule" :table-list="tableData.list"
        :loading="loading"></table-list>
      <Page class="fr pageCon" @on-change="pagechange" @on-page-size-change="pageSizeChange" :total="total"
        :page-size="size" :current="page" show-sizer :page-size-opts="[10, 30, 50, 100]"></Page>
    </div>
  </div>
</template>

<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag';
// 网吧列表
import TableList from './table';
import {
  delRule,
  enabledRule,
  ruleShareList
} from '@/requests/securityCenter';
export default {
  name: 'safetyRules',
  components: {
    HeaderTag,
    TableList,
  },
  data () {
    return {
      total: 0,
      page: 1,
      size: 30,
      tableData: {
        list: [],
      },
      keyword: '',
      loading: false,
    };
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.page = 1
      vm.getSafetyRulesList();
    });
  },
  methods: {
    pageSizeChange (val) {
      this.size = val
      this.getSafetyRulesList()
    },
    pagechange (val) {
      this.page = val
      this.getSafetyRulesList()
    },
    // 获取所有网吧列表
    searchKeyword () {
      this.getSafetyRulesList(1)
    },
    async getSafetyRulesList () {
      // this.loading = true;
      // let res = await getRuleManageList({
      //   current,
      //   size: 30,
      // });
      // this.loading = false;
      // this.tableData.list = res.data.records;
      // this.total = parseInt(res.data.total);
      // this.page = parseInt(res.data.current);
      this.loading = true;
      let res = await ruleShareList({
        id: '',
        ruleId: '',
        ruleName: this.keyword,
        ruleVersion: '',
        ruleRemarks: '',
        shareTime: '',
        checkTime: '',
        checkOperater: '',
        createTime: '',
        createBy: '',
        modifyTime: '',
        modifyBy: '',
        current: this.page,
        size: this.size,
      });
      this.loading = false;
      // console.log(this.$store.state.rule.rules)
      // console.log(121)
      // res.data.records.forEach(ele => {
      //   ele.isCopy = false
      //   this.$store.state.rule.rules.forEach(item => {
      //     if (item.shareId == ele.id)
      //     {
      //       ele.isCopy = true
      //     }
      //   })
      // });
      this.tableData.list = res.data.records;
      this.total = parseInt(res.data.total);
      this.page = parseInt(res.data.current);
    },
    async ruleShareList (current) {
      this.loading = true;
      let res = await ruleShareList({
        id: '',
        ruleId: '',
        ruleName: '',
        ruleVersion: '',
        ruleRemarks: '',
        shareTime: '',
        checkTime: '',
        checkOperater: '',
        createTime: '',
        createBy: '',
        modifyTime: '',
        modifyBy: '',
        current,
        size: 30,
      });
      this.loading = false;
      this.tableData.list = res.data.records;
      this.total = parseInt(res.data.total);
      this.page = parseInt(res.data.current);
    },
    refresh (page) {
      if (page) {
        this.ruleShareList(page);
      } else {
        this.ruleShareList(this.page);
      }
    },
    deleteAllRules () {
      if (this.$refs.tableList.selectedRuleIds().length == 0) {
        return window.$Message.show({
          title: '提示',
          type: 'error',
          msg: '请选择规则',
        });
      }
      window.$Message.show({
        title: '删除规则',
        type: 'info',
        msg:
          '你确定要将已选择的' +
          this.$refs.tableList.selectedRuleIds().length +
          '条规则删除掉吗？',
        cancleBtn: true,
        confirmFn: async () => {
          let res = await delRule({
            id: this.$refs.tableList.selectedRuleIds().join(','),
          });
          if (res.code === 200) {
            window.$Message.hide();
            this.getSafetyRulesList(
              this.$del.delPage(
                this.total,
                this.$refs.tableList.selectedRuleIds().length,
                30,
                this.page
              )
            );
          } else {
            window.$Message.hide();
            setTimeout(() => {
              window.$Message.show({
                title: '删除规则',
                type: 'error',
                msg: res.msg,
                confirmFn: () => {
                  window.$Message.hide();
                  window.$Message.confirmFn = null;
                },
              });
            }, 100);
          }
        },
      });
    },
    rulesStatusAlls (val) {
      let text;
      if (val == 1) {
        text = '启用';
      } else {
        text = '禁用';
      }
      if (this.$refs.tableList.selectedRuleIds().length == 0) {
        return window.$Message.show({
          title: '提示',
          type: 'error',
          msg: '请选择规则',
        });
      }
      window.$Message.show({
        title: text + '规则',
        type: 'info',
        msg:
          '你确定要将已选择的' +
          this.$refs.tableList.selectedRuleIds().length +
          '条规则' +
          text +
          '掉吗？',
        cancleBtn: true,
        confirmFn: async () => {
          let res = await enabledRule({
            id: this.$refs.tableList.selectedRuleIds().join(','),
            type: val,
          });
          if (res.code === 200) {
            window.$Message.hide();
            this.getSafetyRulesList(this.page);
          } else {
            window.$Message.hide();
            setTimeout(() => {
              window.$Message.show({
                title: text + '规则',
                type: 'error',
                msg: res.msg,
                confirmFn: () => {
                  window.$Message.hide();
                  window.$Message.confirmFn = null;
                },
              });
            }, 100);
          }
        },
      });
    },
    async openRule (id, val) {
      let res = await enabledRule({
        id: id,
        type: val,
      });
      if (res.code === 200) {
        this.getSafetyRulesList(this.page);
      } else {
        /* eslint-disable */
        //console.log(res.msg);
      }
    },
    async createRule () {
      let res = await window.$modal.editRulesModal.show();
      if (res)
      {
        this.getSafetyRulesList(1);
      }
    },
    async importRule () {
      let res = await window.$modal.importRule.show();
      if (res)
      {
        this.getSafetyRulesList(1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding-left: 30px;
  text-align: left;
  position: relative;
  z-index: 10;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}

.right {
  float: right;
  padding-right: 20px;

  a {
    margin-left: 6px;
    line-height: normal;
  }
}

.table-content {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
  height: calc(100% - 70px);
  overflow-y: auto;
}

.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;

  >div {
    display: inline-block;
  }
}

.search {
  display: inline-block;
  height: 30px;

  input {
    width: 200px;
    line-height: 30px;
    text-indent: 10px;
    border: 1px solid #eee;
  }

  margin-left: 20px;

  a {
    height: 32px;
    background: #eee;
    width: 32px;
    text-align: center;
    line-height: 32px;
    top: 12px;
  }
}

.sharContainer {
  height: 100%;
  overflow: hidden;
}

.pageCon {
  margin-top: 10px;
}
</style>
